"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var react_2 = __importDefault(require("react"));
var HelperButton_1 = require("./HelperButton");
require("./Section.scss");
var SectionSize;
(function (SectionSize) {
    SectionSize[SectionSize["h1"] = 0] = "h1";
    SectionSize[SectionSize["h2"] = 1] = "h2";
    SectionSize[SectionSize["h3"] = 2] = "h3";
})(SectionSize = exports.SectionSize || (exports.SectionSize = {}));
exports.Section = function (props) {
    var title = props.title, size = props.size, actionButton = props.actionButton, toolTip = props.toolTip, children = props.children, iconName = props.iconName;
    return (react_2.default.createElement("div", { className: "eta-section" },
        react_2.default.createElement("div", { className: "header" },
            iconName && (react_2.default.createElement(react_1.Icon, { iconName: iconName })),
            size === SectionSize.h1 && react_2.default.createElement("h1", null, title),
            size === SectionSize.h2 && react_2.default.createElement("h2", null, title),
            size === SectionSize.h3 && react_2.default.createElement("h3", null, title),
            react_2.default.createElement("div", { className: "space" }),
            actionButton && react_2.default.createElement("div", { className: "action" }, actionButton),
            toolTip && react_2.default.createElement(HelperButton_1.HelperButton, null, toolTip)),
        react_2.default.createElement("div", { className: "lineSeparator" }),
        children));
};
//# sourceMappingURL=Section.js.map